export const getDomain = () => {
  const domain = window.location.hostname
  return domain
}
